<header>
  <img src="assets/svg/BA Logo with Tagline Standard.svg" alt="Blue pulse" />
  <!-- <div class="logo-name">Blue Pulse</div> -->
</header>
